import React,{useState}  from "react"
import { NavLink } from "react-router-dom"
import F from './image/layout/fa.png'

function Contact(props) {
    return (
      <div className='flex flex-col bg-opacity-0 '>
        <div className='flex flex-col hidden md:block '>
          <NavLink to="" className='' activeclassname="route-active">
            <img className="h-48 m-1 rounded-lg" src={F}  onClick={(e) =>  {
                                                e.preventDefault();
                      window.open('https://www.facebook.com/leminhofhaiduong')
                    }}/>
          </NavLink>
        </div>
        <div className='flex flex-col md:hidden '>
          <NavLink to="" className='' activeclassname="route-active">
            <img className="h-32 m-1 rounded-lg" src={F}  onClick={(e) =>  {
                                                e.preventDefault();
                      window.open('https://www.facebook.com/leminhofhaiduong')
                    }}/>
          </NavLink>
        </div>
    </div>
    )
}

export default Contact